/*
   The backend's OpenAPI document, read through the session (`/api/v1/openapi.json` accepts the
   console's JWT; the Basic-gated `/openapi.json` is for the browser Swagger UI, which this
   deployment's CDN does not route to the backend anyway).
*/

import { queryOptions } from "@tanstack/react-query"

import { http } from "@/lib/http"
import { qk } from "@/lib/query-keys"

export const OPENAPI_PATH = "/api/v1/openapi.json"

export function openApiQuery() {
  return queryOptions({
    queryKey: qk.openapi.document(),
    queryFn: () => http.get<unknown>(OPENAPI_PATH),
    staleTime: 5 * 60_000,
  })
}
